/**
 * Lieferdatum-Vorschau: Pickeasy-Termine über App-Proxy (90 Tage) oder einfache Mo–Fr-Fallback-Liste.
 * Modus "both": Lieferung + Abholung gemeinsam auf jeder Datumskarte.
 */
(function () {
  /* Pickeasy liefert die Termine seit Ende Oktober 2026 nur noch über den App-Proxy des Shops.
     Der direkte Logbase-Endpunkt antwortet mit 401 und bleibt nur als Reserve. */
  var SLOTS_APIS = ['/apps/pickeasy/slots', 'https://slots-app.logbase.io/api/slots'];

  function fetchSlotsMonth(payload) {
    var body = JSON.stringify(payload);
    function attempt(i) {
      return fetch(SLOTS_APIS[i], {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: body,
      })
        .then(function (r) {
          if (!r.ok) throw new Error('slots_http_' + r.status);
          return r.json();
        })
        .then(function (json) {
          if (!json || !Array.isArray(json.slots)) throw new Error('slots_invalid');
          return json;
        })
        .catch(function (err) {
          if (i + 1 < SLOTS_APIS.length) return attempt(i + 1);
          throw err;
        });
    }
    return attempt(0);
  }

  function isWeekend(d) {
    var day = d.getDay();
    return day === 0 || day === 6;
  }

  function nextWeekdayAfter(d) {
    var n = new Date(d);
    n.setDate(n.getDate() + 1);
    while (isWeekend(n)) {
      n.setDate(n.getDate() + 1);
    }
    return n;
  }

  function buildBusinessDaysFrom(start, count) {
    var out = [];
    var cur = new Date(start);
    cur.setHours(0, 0, 0, 0);
    if (isWeekend(cur)) {
      cur = nextWeekdayAfter(cur);
    }
    for (var i = 0; i < count; i++) {
      out.push(new Date(cur));
      cur = nextWeekdayAfter(cur);
    }
    return out;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function monthYearPairsFromRange(startDate, endDate) {
    var pairs = [];
    var cur = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    var endMarker = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
    while (cur <= endMarker) {
      pairs.push({ month: cur.getMonth(), year: cur.getFullYear() });
      cur.setMonth(cur.getMonth() + 1);
    }
    return pairs;
  }

  function localDateKey(d) {
    var y = d.getFullYear();
    var m = d.getMonth() + 1;
    var day = d.getDate();
    return (
      y +
      '-' +
      (m < 10 ? '0' : '') +
      m +
      '-' +
      (day < 10 ? '0' : '') +
      day
    );
  }

  function dateKeyFromSlot(slot) {
    var d = new Date(slot.date);
    if (isNaN(d.getTime())) return null;
    d.setHours(0, 0, 0, 0);
    return localDateKey(d);
  }

  function enumerateWeekdays(start, end) {
    var out = [];
    var d = new Date(start);
    d.setHours(0, 0, 0, 0);
    var endD = new Date(end);
    endD.setHours(0, 0, 0, 0);
    while (d <= endD) {
      if (!isWeekend(d)) {
        out.push(new Date(d));
      }
      d.setDate(d.getDate() + 1);
    }
    return out;
  }

  function fetchMergedSlots(shopDomain, locationId, fulfillmentType, horizonDays) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var end = new Date(today);
    end.setDate(end.getDate() + horizonDays);
    var pairs = monthYearPairsFromRange(today, end);

    return Promise.all(
      pairs.map(function (pair) {
        return fetchSlotsMonth({
          myShopifyDomain: shopDomain,
          locationId: locationId,
          fulfillmentType: fulfillmentType,
          month: pair.month,
          year: pair.year,
        });
      })
    ).then(function (responses) {
      var byKey = new Map();
      responses.forEach(function (res) {
        var slots = res.slots || [];
        slots.forEach(function (s) {
          var key = dateKeyFromSlot(s);
          if (!key) return;
          if (!byKey.has(key)) {
            byKey.set(key, s);
          } else {
            var existing = byKey.get(key);
            var a = (s.timeSlots && s.timeSlots.length) || 0;
            var b = (existing.timeSlots && existing.timeSlots.length) || 0;
            if (a > b) byKey.set(key, s);
          }
        });
      });
      return Array.from(byKey.values()).sort(function (a, b) {
        return new Date(a.date) - new Date(b.date);
      });
    });
  }

  function slotMapFromSlots(slots) {
    var m = new Map();
    slots.forEach(function (s) {
      var k = dateKeyFromSlot(s);
      if (!k) return;
      if (!m.has(k)) {
        m.set(k, s);
      } else {
        var ex = m.get(k);
        var a = (s.timeSlots && s.timeSlots.length) || 0;
        var b = (ex.timeSlots && ex.timeSlots.length) || 0;
        if (a > b) m.set(k, s);
      }
    });
    return m;
  }

  function slotCount(slot) {
    return (slot && slot.timeSlots && slot.timeSlots.length) || 0;
  }

  /**
   * Normale Anzahl Zeitfenster je Wochentag (Maximum im Abfragezeitraum).
   * So zählt z. B. ein Dienstag mit nur einem Zeitfenster (halber Tag) als normal.
   */
  function weekdayMaxFromMap(slotMap) {
    var max = {};
    slotMap.forEach(function (slot) {
      var d = new Date(slot.date);
      if (isNaN(d.getTime())) return;
      var wd = d.getDay();
      var n = slotCount(slot);
      if (!max[wd] || n > max[wd]) max[wd] = n;
    });
    return max;
  }

  /**
   * 0 Zeitfenster = ausgebucht.
   * „wenige Plätze“ nur, wenn nur noch 1 Zeitfenster frei ist, der Wochentag aber
   * normalerweise mehrere hat (also schon Fenster belegt sind).
   */
  function statusFromSlot(slot, normalCount) {
    var n = slotCount(slot);
    if (n === 0) return 'booked';
    if (n === 1 && (normalCount || 1) > 1) return 'few';
    return 'available';
  }

  function statusForDate(slotMap, date, maxByWeekday) {
    if (!slotMap) return null;
    var slot = slotMap.get(localDateKey(date));
    if (!slot) return 'booked';
    return statusFromSlot(slot, maxByWeekday ? maxByWeekday[date.getDay()] : 1);
  }

  /**
   * Pro Werktag im Fenster [heute … heute+horizon]: kein API-Slot = ausgebucht;
   * 1 timeSlot = wenige; 2+ = verfügbar (ohne Zusatzzeile).
   */
  function buildApiCalendarItems(slotMap, horizonDays, maxCards) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var maxDate = new Date(today);
    maxDate.setDate(maxDate.getDate() + horizonDays);
    var weekdays = enumerateWeekdays(today, maxDate);
    var limited = weekdays.slice(0, Math.max(1, maxCards));
    var maxByWeekday = weekdayMaxFromMap(slotMap);
    return limited.map(function (date) {
      return { dateObj: date, status: statusForDate(slotMap, date, maxByWeekday) };
    });
  }

  /**
   * Modus "both": pro Werktag Status für Lieferung und Abholung.
   * Ist eine der beiden Abfragen fehlgeschlagen (Map = null), entfällt diese Zeile.
   */
  function buildDualCalendarItems(deliveryMap, pickupMap, horizonDays, maxCards) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var maxDate = new Date(today);
    maxDate.setDate(maxDate.getDate() + horizonDays);
    var weekdays = enumerateWeekdays(today, maxDate);
    var limited = weekdays.slice(0, Math.max(1, maxCards));
    var deliveryMax = deliveryMap ? weekdayMaxFromMap(deliveryMap) : null;
    var pickupMax = pickupMap ? weekdayMaxFromMap(pickupMap) : null;
    return limited.map(function (date) {
      return {
        dateObj: date,
        delivery: statusForDate(deliveryMap, date, deliveryMax),
        pickup: statusForDate(pickupMap, date, pickupMax),
      };
    });
  }

  function formatDate(date, wdFmt, dmFmt) {
    var wd = wdFmt.format(date).replace(/\.$/, '').trim();
    return wd + ', ' + dmFmt.format(date);
  }

  function renderCards(track, items, locale, labelBooked, labelFew) {
    var wdFmt = new Intl.DateTimeFormat(locale, { weekday: 'short' });
    var dmFmt = new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit' });

    track.textContent = '';
    items.forEach(function (item) {
      var status = item.status;

      var card = document.createElement('div');
      card.className = 'delivery-date-preview__card';
      card.setAttribute('data-status', status);
      card.setAttribute('role', 'listitem');

      var dateEl = document.createElement('div');
      dateEl.className = 'delivery-date-preview__date';
      dateEl.textContent = formatDate(item.dateObj, wdFmt, dmFmt);
      card.appendChild(dateEl);

      if (status !== 'available') {
        var st = document.createElement('div');
        st.className = 'delivery-date-preview__status';
        st.textContent = status === 'booked' ? labelBooked : labelFew;
        card.appendChild(st);
      }

      track.appendChild(card);
    });
  }

  function renderDualCards(track, items, locale, labels) {
    var wdFmt = new Intl.DateTimeFormat(locale, { weekday: 'short' });
    var dmFmt = new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit' });

    function statusText(status) {
      if (status === 'booked') return labels.booked;
      if (status === 'few') return labels.few;
      return labels.available;
    }

    track.textContent = '';
    items.forEach(function (item) {
      var rows = [];
      if (item.delivery) rows.push({ label: labels.delivery, status: item.delivery, type: 'delivery' });
      if (item.pickup) rows.push({ label: labels.pickup, status: item.pickup, type: 'pickup' });

      var allBooked = rows.length > 0 && rows.every(function (r) {
        return r.status === 'booked';
      });

      var card = document.createElement('div');
      card.className = 'delivery-date-preview__card delivery-date-preview__card--dual';
      card.setAttribute('data-status', allBooked ? 'booked' : 'available');
      card.setAttribute('role', 'listitem');

      var dateEl = document.createElement('div');
      dateEl.className = 'delivery-date-preview__date';
      dateEl.textContent = formatDate(item.dateObj, wdFmt, dmFmt);
      card.appendChild(dateEl);

      var rowsEl = document.createElement('div');
      rowsEl.className = 'delivery-date-preview__rows';
      rows.forEach(function (r) {
        var rowEl = document.createElement('div');
        rowEl.className = 'delivery-date-preview__row';
        rowEl.setAttribute('data-status', r.status);
        rowEl.setAttribute('data-type', r.type);

        var labelEl = document.createElement('span');
        labelEl.className = 'delivery-date-preview__row-label';
        labelEl.textContent = r.label;

        var stEl = document.createElement('span');
        stEl.className = 'delivery-date-preview__row-status';
        stEl.textContent = statusText(r.status);

        rowEl.appendChild(labelEl);
        rowEl.appendChild(stEl);
        rowsEl.appendChild(rowEl);
      });
      card.appendChild(rowsEl);

      track.appendChild(card);
    });
  }

  function attachCarouselControls(track, btnPrev, btnNext) {
    function scrollStep(dir) {
      var card = track.querySelector('.delivery-date-preview__card');
      var gap = parseFloat(getComputedStyle(track).gap) || 12;
      var step = card ? card.offsetWidth + gap : 140;
      var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
      track.scrollBy({ left: dir * step, behavior: behavior });
    }

    btnPrev.addEventListener('click', function () {
      scrollStep(-1);
    });
    btnNext.addEventListener('click', function () {
      scrollStep(1);
    });

    track.addEventListener(
      'wheel',
      function (e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          return;
        }
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 0) {
          return;
        }
        var delta = e.deltaY;
        if (delta > 0 && track.scrollLeft >= max - 0.5) {
          return;
        }
        if (delta < 0 && track.scrollLeft <= 0.5) {
          return;
        }
        track.scrollLeft = Math.max(0, Math.min(max, track.scrollLeft + delta));
        e.preventDefault();
      },
      { passive: false }
    );

    var dragActive = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') {
        return;
      }
      if (e.pointerType === 'mouse' && e.button !== 0) {
        return;
      }
      dragActive = true;
      dragStartX = e.clientX;
      dragStartScrollLeft = track.scrollLeft;
      track.classList.add('delivery-date-preview__track--dragging');
      try {
        track.setPointerCapture(e.pointerId);
      } catch (err) {}
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragActive) {
        return;
      }
      var dx = e.clientX - dragStartX;
      track.scrollLeft = dragStartScrollLeft - dx;
    });

    function endPointerDrag(e) {
      if (!dragActive) {
        return;
      }
      dragActive = false;
      track.classList.remove('delivery-date-preview__track--dragging');
      try {
        track.releasePointerCapture(e.pointerId);
      } catch (err) {}
    }

    track.addEventListener('pointerup', endPointerDrag);
    track.addEventListener('pointercancel', endPointerDrag);
  }

  function initRoot(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var count = parseInt(root.dataset.daysCount || '24', 10);
    var locale = root.dataset.locale || 'de';
    var labelBooked = root.dataset.labelBooked || '';
    var labelFew = root.dataset.labelFew || '';
    var shopDomain = root.dataset.shopDomain || '';
    var locationId = (root.dataset.locationId || '').trim();
    var fulfillmentType = root.dataset.fulfillmentType || 'delivery';
    var horizonDays = parseInt(root.dataset.horizonDays || '90', 10);
    var fallbackOnError = root.dataset.fallbackOnError === 'true';
    var errorText = root.dataset.errorText || '';
    var dualLabels = {
      delivery: root.dataset.labelDelivery || 'LKW',
      pickup: root.dataset.labelPickup || 'Hof',
      available: root.dataset.labelAvailable || 'frei',
      booked: labelBooked,
      few: labelFew,
    };

    var track = root.querySelector('[data-delivery-date-track]');
    var btnPrev = root.querySelector('[data-delivery-date-prev]');
    var btnNext = root.querySelector('[data-delivery-date-next]');
    var loadingEl = root.querySelector('[data-delivery-date-loading]');
    if (!track || !btnPrev || !btnNext) return;

    function buildFallbackItems() {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var dates = buildBusinessDaysFrom(today, Math.max(1, count));
      return dates.map(function (date) {
        return { dateObj: date, status: 'available' };
      });
    }

    function showErrorMessage() {
      track.textContent = '';
      var p = document.createElement('p');
      p.className = 'delivery-date-preview__error';
      p.textContent = errorText;
      track.appendChild(p);
    }

    function handleError() {
      if (fallbackOnError) {
        renderCards(track, buildFallbackItems(), locale, labelBooked, labelFew);
      } else {
        showErrorMessage();
      }
    }

    var controlsAttached = false;
    function finish() {
      if (loadingEl) loadingEl.hidden = true;
      if (!controlsAttached) {
        attachCarouselControls(track, btnPrev, btnNext);
        controlsAttached = true;
      }
    }

    function run() {
      var useApi = locationId && shopDomain;

      if (!useApi) {
        if (loadingEl) loadingEl.hidden = true;
        renderCards(track, buildFallbackItems(), locale, labelBooked, labelFew);
        finish();
        return;
      }

      if (loadingEl) loadingEl.hidden = false;

      if (fulfillmentType === 'both') {
        Promise.all([
          fetchMergedSlots(shopDomain, locationId, 'delivery', horizonDays).catch(function () {
            return null;
          }),
          fetchMergedSlots(shopDomain, locationId, 'pickup', horizonDays).catch(function () {
            return null;
          }),
        ])
          .then(function (results) {
            var deliverySlots = results[0];
            var pickupSlots = results[1];
            if (!deliverySlots && !pickupSlots) throw new Error('slots_both_failed');
            var items = buildDualCalendarItems(
              deliverySlots ? slotMapFromSlots(deliverySlots) : null,
              pickupSlots ? slotMapFromSlots(pickupSlots) : null,
              horizonDays,
              count
            );
            renderDualCards(track, items, locale, dualLabels);
          })
          .catch(handleError)
          .finally(finish);
        return;
      }

      fetchMergedSlots(shopDomain, locationId, fulfillmentType, horizonDays)
        .then(function (slots) {
          var map = slotMapFromSlots(slots);
          var items = buildApiCalendarItems(map, horizonDays, count);
          renderCards(track, items, locale, labelBooked, labelFew);
        })
        .catch(handleError)
        .finally(finish);
    }

    run();

    /* Preisrechner: Umschalten zwischen Lieferung und Abholung lädt die passenden Termine */
    var headingEl = root.querySelector('.delivery-date-preview__heading');
    var headingDelivery = headingEl ? headingEl.textContent : '';
    document.addEventListener('fr:fulfillment-change', function (e) {
      var type = e.detail && e.detail.type === 'pickup' ? 'pickup' : 'delivery';
      if (fulfillmentType === type || root.dataset.fulfillmentType === 'both') return;
      fulfillmentType = type;
      root.dataset.fulfillmentType = type;
      if (headingEl) headingEl.textContent = type === 'pickup' ? 'Abholung zum Wunschtermin' : headingDelivery;
      track.scrollLeft = 0;
      run();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-delivery-date-preview]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var scope = event.target || document;
    if (scope.matches && scope.matches('[data-delivery-date-preview]')) {
      initRoot(scope);
      return;
    }
    scope.querySelectorAll('[data-delivery-date-preview]').forEach(initRoot);
  });
})();
